import React from "react";
import { Form, Row, Col } from "react-bootstrap";

const dayLabels = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
const dayValues = [1, 2, 4, 8, 16, 32, 64];

const CalendarRecurrenceForm = ({ recurrenceRule, setRecurrenceRule }) => {
  const {
    recurrenceType,
    recurrenceInterval,
    dayOfWeekMask,
    endType,
    endCount,
    endDate,
  } = recurrenceRule;

  const update = (key, value) =>
    setRecurrenceRule((r) => ({ ...r, [key]: value }));

  const toggleDay = (i) =>
    update("dayOfWeekMask", dayOfWeekMask ^ dayValues[i]);

  return (
    <>
      <Form.Group className="mb-2">
        <Form.Label className="fw-semibold small">
          Wiederholung
        </Form.Label>
        <Form.Select
          size="sm"
          value={recurrenceType}
          onChange={(e) => update("recurrenceType", e.target.value)}
        >
          <option value="none">Keine</option>
          <option value="DAILY">Täglich</option>
          <option value="WEEKLY">Wöchentlich</option>
          <option value="MONTHLY">Monatlich</option>
          <option value="YEARLY">Jährlich</option>
        </Form.Select>
      </Form.Group>

      {recurrenceType !== "none" && (
        <>
          {/* Interval */}
          <Row className="align-items-center mb-2">
            <Col xs="auto" className="small">Alle</Col>
            <Col xs={3}>
              <Form.Control
                size="sm"
                type="number"
                min={1}
                value={recurrenceInterval}
                onChange={(e) =>
                  update("recurrenceInterval", Number(e.target.value))
                }
              />
            </Col>
            <Col className="small">
              {recurrenceType === "DAILY"
                ? "Tage"
                : recurrenceType === "WEEKLY"
                ? "Wochen"
                : recurrenceType === "MONTHLY"
                ? "Monate"
                : "Jahre"}
            </Col>
          </Row>

          {/* Weekly days */}
          {recurrenceType === "WEEKLY" && (
            <div className="d-flex gap-1 mb-2">
              {dayLabels.map((d, i) => (
                <Form.Check
                  key={i}
                  inline
                  type="checkbox"
                  label={d}
                  checked={Boolean(dayOfWeekMask & dayValues[i])}
                  onChange={() => toggleDay(i)}
                />
              ))}
            </div>
          )}

          {/* End options */}
          <Form.Group>
            <Form.Check
              type="radio"
              name="endType"
              label="Kein Ende"
              checked={endType === "NEVER"}
              onChange={() => update("endType", "NEVER")}
            />

            <Form.Check
              type="radio"
              name="endType"
              className="mt-1"
              checked={endType === "END_BY_COUNT"}
              onChange={() => update("endType", "END_BY_COUNT")}
              label={
                <Row className="align-items-center">
                  <Col xs="auto" className="small">Nach</Col>
                  <Col xs={3}>
                    <Form.Control
                      size="sm"
                      type="number"
                      min={1}
                      disabled={endType !== "END_BY_COUNT"}
                      value={endCount}
                      onChange={(e) =>
                        update("endCount", Number(e.target.value))
                      }
                    />
                  </Col>
                  <Col className="small">Terminen</Col>
                </Row>
              }
            />

            <Form.Check
              type="radio"
              name="endType"
              className="mt-1"
              checked={endType === "END_BY_DATE"}
              onChange={() => update("endType", "END_BY_DATE")}
              label={
                <Row className="align-items-center">
                  <Col xs="auto" className="small">Bis</Col>
                  <Col>
                    <Form.Control
                      size="sm"
                      type="date"
                      disabled={endType !== "END_BY_DATE"}
                      value={endDate || ""}
                      onChange={(e) =>
                        update("endDate", e.target.value)
                      }
                    />
                  </Col>
                </Row>
              }
            />
          </Form.Group>
        </>
      )}
    </>
  );
};

export default CalendarRecurrenceForm;
